import styled from 'styled-components'

export const StatusWrapper = styled.section`
    flex: 1;
    padding: 48px 24px;
    border-radius: 15px;
    background: ${({ theme }) => theme.colors.primaryWhite};
`

export const StatusContainer = styled.div`
    width: 100%;
    max-width: 800px;
    min-width: 520px;
    margin: 0 auto;
    display: grid;
    grid-template-areas:
        'survey-link survey-link published-status'
        'participation-rate close-survey close-survey'
        'email-templates email-templates email-templates';
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, min-content);
    gap: 20px;

    @media (max-width: 1026px) {
        grid-template-areas:
            'survey-link survey-link'
            'published-status participation-rate'
            'close-survey close-survey'
            'email-templates email-templates';
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(4, min-content);
    }
`
